/**
 * 관리자 레이아웃 컴포넌트
 */

import React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ROUTES } from '../../../../shared/constants/routes';
import styles from './AdminLayout.module.css';

export const AdminLayout: React.FC = () => {
  const { authState, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
  };

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  React.useEffect(() => {
    if (!authState.isAuthenticated) {
      navigate(ROUTES.ADMIN.LOGIN);
    }
  }, [authState.isAuthenticated, navigate]);

  if (!authState.isAuthenticated) {
    return null;
  }

  return (
    <div className={styles.adminLayout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <h2>관리자 페이지</h2>
          <p>{authState.user?.username}</p>
        </div>

        <nav className={styles.sidebarNav}>
          <Link to={ROUTES.ADMIN.DASHBOARD} className={styles.navItem}>
            대시보드
          </Link>

          {/* 메인 슬라이더 - 정적 이미지 사용으로 비활성화 */}
          {/* <Link to={ROUTES.ADMIN.SLIDER} className={styles.navItem}>
            메인 슬라이더
          </Link> */}

          {/* 게시판 관리 - 각 게시판별로 분리 */}
          <Link to={ROUTES.ADMIN.BOARD_SUNDAY_SCHOOL} className={styles.navItem}>
            교회학교 게시판
          </Link>
          <Link to={ROUTES.ADMIN.BOARD_NEWS} className={styles.navItem}>
            교회소식 게시판
          </Link>
          <Link to={ROUTES.ADMIN.BOARD_GALLERY} className={styles.navItem}>
            갤러리 게시판
          </Link>
          <Link to={ROUTES.ADMIN.BOARD_BULLETIN} className={styles.navItem}>
            주보 게시판
          </Link>

          {/* <Link to={`${ROUTES.ADMIN.DASHBOARD}/new-family`} className={styles.navItem}>
            새가족 관리
          </Link> */}
        </nav>

        <div className={styles.sidebarFooter}>
          <button onClick={handleLogout} className={styles.logoutButton}>
            로그아웃
          </button>
          <Link to={ROUTES.HOME} className={styles.homeLink}>
            홈페이지로 이동
          </Link>
        </div>
      </aside>

      <main className={styles.mainContent}>
        <Outlet />
      </main>
    </div>
  );
};
